import React, { createContext, FC, PropsWithChildren, useCallback, useState } from 'react';

import { DAY_OF_WEEK, DIFFICULTY_LEVEL } from '../constants';

interface DifficultyContextProps {
  level?: DIFFICULTY_LEVEL;
  setLevel: React.Dispatch<React.SetStateAction<DIFFICULTY_LEVEL>>;
  changeLevel: (newLevel: DIFFICULTY_LEVEL) => void;
  dayOfWeek?: DAY_OF_WEEK;
  setDayOfWeek: React.Dispatch<React.SetStateAction<DAY_OF_WEEK | undefined>>;
  hasChangedLevel: boolean;
}

export const DifficultyContext = createContext<DifficultyContextProps | null>(null);

export const DifficultyProvider: FC<PropsWithChildren> = ({ children }) => {
  const [level, setLevel] = useState<DIFFICULTY_LEVEL>(DIFFICULTY_LEVEL.INTERMEDIATE);
  const [dayOfWeek, setDayOfWeek] = useState<DAY_OF_WEEK>();
  const [hasChangedLevel, setHasChangedLevel] = useState(false);

  const changeLevel = useCallback((newLevel: DIFFICULTY_LEVEL) => {
    setHasChangedLevel(true);
    setLevel(newLevel);
  }, []);

  return (
    <DifficultyContext.Provider
      value={{ level, setLevel, changeLevel, dayOfWeek, setDayOfWeek, hasChangedLevel }}
    >
      {children}
    </DifficultyContext.Provider>
  );
};
